import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { GlobalMethodsService } from '../../../services/global-methods.service';

@Component({
  selector: 'app-billing-data',
  templateUrl: './billing-data.component.html',
  styleUrls: ['./billing-data.component.scss'],
})
export class BillingDataComponent implements OnInit {

  public billingDataForm: FormGroup;
  @Input('nameHolder') nameHolder; 
  @Input('addressHolder') addressHolder; 
  @Input('bankAccountHolder') bankAccountHolder; 

  constructor(private modalCtrl: ModalController,
              private formBuilder: FormBuilder,
              public gms: GlobalMethodsService) { }

  ngOnInit() {
    this.billingDataForm = this.formBuilder.group({
      full_name: new FormControl(this.nameHolder, [Validators.required]),
      address: new FormControl(this.addressHolder, [Validators.required]),
      iban: new FormControl(this.bankAccountHolder, [Validators.required])
    });
  }

  ionViewWillEnter(){
    this.gms.analyticsTrackEvent('openScreen', {screenName: 'Datos Facturacion', contentGroup: 'Facturas'});
  }

  dismiss(value) {
    this.modalCtrl.dismiss({result: value});
  }

  public async onSubmit() {
    if (this.billingDataForm.valid) {
      // TO DO
    } else {
      this.validateAllFormFields(this.billingDataForm);
    }
  }

  isFieldValid(field: string) {
    return !this.billingDataForm.get(field).valid && this.billingDataForm.get(field).touched;
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
        const control = formGroup.get(field);
        if (!control.valid){
          this.gms.analyticsTrackEvent('form_error', {eventCategory: 'SICOR/Datos Facturacion', eventAction: 'Error/Form: Datos Facturacion', eventLabel:'Campo: ' + field});
        }
        if (control instanceof FormControl) {
            control.markAsTouched({onlySelf: true});
        } else if (control instanceof FormGroup) {
            this.validateAllFormFields(control);
        }
    });
  }

}
